
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 41.91 42.89"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M40 22.79h-3.14L26.4 16a1 1 0 10-1 1.6l8 5.24H8.56l8-5.24a1 1 0 10-1.04-1.6L5.05 22.79H1.93A1.94 1.94 0 000 24.72V41a1.93 1.93 0 001.93 1.93H40A1.92 1.92 0 0041.91 41V24.72A1.93 1.93 0 0040 22.79zm-.07 18.1L2 41l-.07-16.21 34.53-.06H39.91z"}}),_c('path',{attrs:{"d":"M8.68 28.86a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1zM13.54 28.86a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1zM18.62 28.86a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1zM23.65 28.86a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1zM28.28 28.86a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1zM33.82 28.86a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1zM16.78 8.9a1 1 0 00.71.29h2.38v1a3.54 3.54 0 00-2 1.08 4.34 4.34 0 00-.87 3.06 3.88 3.88 0 004.12 3.78 3.64 3.64 0 003-1.24 4.71 4.71 0 00.75-3.61 1 1 0 00-2 .4 2.82 2.82 0 01-.34 1.94 1.71 1.71 0 01-1.42.51A1.86 1.86 0 0119 14.26v-.1a2.37 2.37 0 01.44-1.61 1.86 1.86 0 011.43-.55 1 1 0 001-1V9.19h2.32a1 1 0 00.71-.29l4.32-4.32a1 1 0 00.29-.71V1a1 1 0 00-1-1H12.88a1 1 0 00-1 1v2.58a1 1 0 00.3.71zM13.88 2h13.63v1.46l-3.73 3.73h-5.87l-4-4z"}})])])
          )
        }
      }
    